/**
 * Created by rorschach on 2018/1/25.
 */
import React from "react";
import utils from "../utils/utils";
import querystring from "querystring";

class RootView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mobxDevtools: null
    };
  }

  async componentDidMount() {
    console.log("RootView init");
    if (utils.isDebug()) {
      /*await this.initMobxDevTools();
      if (!await this.initWeinreDebug()) {
        await this.initVConsole();
      }*/
    }
  }

  getHashQuery() {
    return querystring.parse(window.location.hash.slice(1));
  }

  async initWeinreDebug() {
    const hashQuery = this.getHashQuery();
    if (hashQuery.weinre_host) {
      utils.appendScript(
        `http://${hashQuery.weinre_host}/target/target-script-min.js#anonymous`
      );
      return true;
    }
    return false;
  }

  async initVConsole() {
    const VConsole = await import("vconsole");
    new VConsole();
    return true;
  }

  async initMobxDevTools() {
    const Devtools = await import("mobx-react-devtools");
    this.setState({
      mobxDevtools: <Devtools.default position={{ bottom: -1, left: -3 }} />
    });
    return true;
  }

  render() {
    return (
      <div className="xy-app-root-view">
        {this.props.children}
        {this.state.mobxDevtools}
      </div>
    );
  }
}

export default RootView;



// WEBPACK FOOTER //
// ./src/pages/RootView.js